import { render, staticRenderFns } from "./distributoraudit.vue?vue&type=template&id=3a5fb846&scoped=true"
import script from "./distributoraudit.vue?vue&type=script&lang=js"
export * from "./distributoraudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fb846",
  null
  
)

export default component.exports